import AppHeaderActionBar from '@/shared/components/layout/AppHeaderActionBar';
import AppHeaderBreadcrumbTrail from '@/shared/components/layout/AppHeaderBreadcrumbTrail';
import MyContext from '@/shared/contexts/AppContext';
import AppHeaderUserMenu from '@/shared/components/layout/AppHeaderUserMenu';
import NotificationBell from '@/shared/components/NotificationBell';
import { useAppPageHeader } from '@/shared/hooks/useAppPageHeader';
import { useNavigationView } from '@/shared/hooks/useNavigationView';
import { useContext } from 'react';
import { LuMenu, LuX } from 'react-icons/lu';

type AppHeaderProps = {
  sidebarCollapsed: boolean;
  onMenuToggle: () => void;
};

export default function AppHeader({ sidebarCollapsed, onMenuToggle }: AppHeaderProps) {
  const context = useContext(MyContext);
  const { viewLabel } = useNavigationView();
  const {
    showBreadcrumb,
    showActionBar,
    hasActions,
    actions,
    breadcrumbItems,
  } = useAppPageHeader();

  if (!context) return null;
  const { state } = context;

  return (
    <div className="app-page-chrome d-print-none">
      <header className="app-header">
        <div className="app-header__row">
          <div className="app-header__left">
            <button
              type="button"
              className="app-header__menu-btn"
              onClick={onMenuToggle}
              title={sidebarCollapsed ? 'Abrir menu' : 'Fechar menu'}
              aria-label={sidebarCollapsed ? 'Abrir menu' : 'Fechar menu'}
              aria-expanded={!sidebarCollapsed}
            >
              {sidebarCollapsed ? <LuMenu size={22} aria-hidden /> : <LuX size={22} aria-hidden />}
            </button>
            {showBreadcrumb && <AppHeaderBreadcrumbTrail items={breadcrumbItems} />}
          </div>

          <div className="app-header__center">
            {/* <h1 className="app-header__title">{titulo}</h1> */}
          </div>

          <div className="app-header__right">
            <div className="app-header__search-group">
              <div className="app-header__search" role="search">
                <input
                  type="search"
                  className="form-control"
                  placeholder="Buscar…"
                  disabled
                  aria-label="Busca (em breve)"
                  title="Busca global — em desenvolvimento"
                />
              </div>
              <NotificationBell variant="header" />
            </div>
            <AppHeaderUserMenu
              nome={state.nome}
              username={state.username}
              viewLabel={viewLabel}
            />
          </div>
        </div>
      </header>

      {showActionBar && (
        <AppHeaderActionBar hasActions={hasActions} actions={actions} />
      )}
    </div>
  );
}
